module.exports = __webpack_public_path__ + "img/thema-five-about.0a923f3d.jpg";